import type { CoachStyle, IDictionary } from '@/types';

export type CoachSortBy =
  | 'first_name'
  | 'focus'
  | 'email'
  | 'coach_status'
  | 'capacity'
  | 'members'
  | 'active_chem_calls'
  | 'utilization'
  | 'rate'
  | 'start_date'
  | 'updated_at';

export interface CoachColumn {
  key: CoachSortBy | 'calendar_url' | 'standard_rate' | 'executive_rate';
  label: string;
  sortable: boolean;
}

export const COACH_COLUMNS: CoachColumn[] = [
  { key: 'first_name', label: 'Name', sortable: true },
  { key: 'focus', label: 'Focus', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'coach_status', label: 'Status', sortable: true },
  { key: 'active_chem_calls', label: 'Chemistry Calls', sortable: true },
  { key: 'members', label: 'Members', sortable: true },
  { key: 'capacity', label: 'Capacity', sortable: true },
  {
    key: 'utilization',
    label: 'Utilization - CC/Members/Capacity',
    sortable: true,
  },
  { key: 'rate', label: 'Rate - Std/Exec', sortable: true },
  { key: 'calendar_url', label: 'Scheduling', sortable: false },
  { key: 'start_date', label: 'Start Date', sortable: true },
  { key: 'updated_at', label: 'Updated by Coach', sortable: true },
];

export const STYLE_OPTIONS: IDictionary<CoachStyle> = {
  ENTREPRENEUR: {
    description:
      "As an entrepreneur and founder, you're uniquely positioned to help Members start and grow their own companies.",
    title: 'Entrepreneurship & Founder',
  },
  FUNCTIONAL: {
    description:
      'You are an expert at your craft, and help guide your Members along your journey.',
    title: 'Functional Expert',
  },
  MANAGEMENT: {
    description:
      'You understand career progression, help Members unlock their leadership potential, and grow into phenomenal managers.',
    title: 'Leadership & Management',
  },
  WELLBEING: {
    description:
      'You bring a holistic approach to your Members, focusing on mindset and wellbeing.',
    title: 'Mindset & Wellbeing',
  },
};
